import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import App from "./App";
import InboxPage from "./pages/InboxPage";
import WaitingPage from "./pages/WaitingPage";
import NextPage from "./pages/NextPage";
import ScheduledPage from "./pages/ScheduledPage";
import SomedayPage from "./pages/SomedayPage";
import FocusPage from "./pages/FocusPage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectPage from "./pages/ProjectPage";
import TrashPage from "./pages/TrashPage";
import LogbookPage from "./pages/LogbookPage";
import LoginPage from "./pages/LoginPage";
import LogoutPage from "./pages/LogoutPage";
import AddTaskPage from "./pages/AddTaskPage";
import TestPage from "./pages/TestPage";
// import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
// import { dark } from "@material-ui/core/styles/createPalette";
import { connect } from "react-redux";
import BottomNavigations from './containers/BottomNavigations';
import TodayPage from './pages/TodayPage';
import isPWA from './helpers/isPWA';

const RootRouter = ({themeColor}) => {

const [width, setWidth] = React.useState(window.innerWidth);
const [open, setOpen] = React.useState(true);

const handleWindowSizeChange = () => {
  setWidth({ width: window.innerWidth });
};

useEffect(() => {
  window.addEventListener("resize", handleWindowSizeChange);
});

useEffect(() => {
  if (window.innerWidth <= 1000) {
    setOpen(false);
  }
  window.removeEventListener("resize", handleWindowSizeChange);
  

}, []);


const isStandalone = isPWA;

const isMobile = isStandalone || width <= 1328 || width.width <= 1328;

//TO DO 
//   const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

//   const theme = React.useMemo(
//     () =>
//       createMuiTheme({
//         palette: {
//           type: prefersDarkMode ? "dark" : "light"
//         }
//       }),
//     [prefersDarkMode]
//   );

  const theme = createMuiTheme({
    palette: {
      type: themeColor
    }
  });

  return (
    <ThemeProvider theme={theme}>
    <Router>
      <Switch>
        <Route exact={true} path="/" component={LoginPage} />
        <Route path="/inbox" component={InboxPage} />
        <Route path="/logbook" component={LogbookPage} />
        <Route path="/trash" component={TrashPage} />
        <Route path="/next" component={NextPage} />
        <Route path="/wating" component={WaitingPage} />
        <Route path="/scheduled" component={ScheduledPage} />
        <Route path="/someday" component={SomedayPage} />
        <Route path="/focus" component={FocusPage} />
        <Route path="/projects" component={ProjectsPage} />
        <Route path="/project/:projectId" component={ProjectPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/logout" component={LogoutPage} />
        <Route path="/add" component={AddTaskPage} />
        <Route path="/today" component={TodayPage} />
        <Route path="/test" component={TestPage} />
      </Switch>
      {isMobile && <BottomNavigations /> }
    </Router>
   
    </ThemeProvider>
  );
};

const mapStateToProps = (state, props) => {
    return {
        themeColor: !state.switchColor ? 'light' : 'dark'
  };
}
  
export default connect(mapStateToProps, null)(RootRouter);
